import { StatusDefinitions } from "../../utils/data";

const StatusCol = ({ status = "", type = "" }) => {
  return (
    <td>
      <span className={StatusDefinitions?.[type][status]?.color}>
        {StatusDefinitions?.[type][status]?.value}
      </span>
    </td>
  );
};

export default StatusCol;
